import { apiService } from './api';
import { User } from '../types';

export interface UpdateUserData {
  name: string;
  email: string;
  nationality?: string;
  document_type?: string;
  document_number?: string;
  date_of_birth?: string;
  phone?: string;
  country_code?: string;
}
export class UserService {
  async getMe(): Promise<User> {
    try {
      const response = await apiService.get<any>('/me');
      
      // Map backend fields to frontend fields  
      const userData = response.data;
      return {
        ...userData,
        date_of_birth: userData.birth_date, // Map birth_date to date_of_birth
      };
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to fetch user data');
    }
  }

  async updateProfile(userData: UpdateUserData): Promise<User> {
    try {
      // Map frontend fields to backend fields
      const backendData = {
        name: userData.name,
        email: userData.email,
        nationality: userData.nationality,
        document_type: userData.document_type,
        document_number: userData.document_number,
        birth_date: userData.date_of_birth, // Map date_of_birth to birth_date
        phone: userData.phone,
        country_code: userData.country_code,
      };

      const response = await apiService.put<any>('/me', backendData);
      
      // Map backend response to frontend format
      return {
        ...response.data,
        date_of_birth: response.data.birth_date, // Map birth_date back to date_of_birth
      };
    } catch (error: any) {
      const message = error.response?.data?.message || 'Failed to update profile';
      const errors = error.response?.data?.errors;
      
      if (errors) {
        const errorMessages = Object.values(errors).flat().join(', ');
        throw new Error(`${message}: ${errorMessages}`);
      }
      
      throw new Error(message);
    }
  }
}

export const userService = new UserService();
